import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportRecord } from 'src/app/models/report';


export interface DialogData {
  data: ReportRecord;
}

@Component({
  selector: 'app-date-detail-dialog',
  templateUrl: './date-detail-dialog.component.html',
  styleUrls: ['./date-detail-dialog.component.css']
})
export class DateDetailDialogComponent implements OnInit {
  state: string;
  date: string;
  cause: string;
  constructor(
    public auth: AuthService,
    private dialogRef: MatDialogRef<DateDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit() {
    const r = this.data.data;
    this.cause = r.request.cause;
    this.date = r.dateText;
    this.state = r.getState();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}
